import { DesktopHeader } from './header/DesktopHeader';
import { HeaderMobilePage } from './header/HeaderMobilePage';
const Header = () => {
  return <header className="sticky top-0 z-40 w-full border-b bg-white">
      <div className="container mx-auto px-[16px]">
        <div className="flex h-16 items-center">
          {/* Mobile & Tablet Layout (≤834px) */}
          <HeaderMobilePage />

          {/* Desktop Layout (>834px) */}
          <DesktopHeader />
        </div>
      </div>
    </header>;
};
export default Header;